import {
    Row, Container, Col
} from 'reactstrap';
import React, {useEffect, useState, Component, useRef} from "react";
import PlayerList from "./partials/PlayerList";
import _ from "./Trans";
import {faMoneyBillTransfer, faArrowsUpDown, faPlaneDeparture, faHome, faCircle, faSuitcaseMedical, faRecycle, faRing, faC} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import token from './AuthToken';
import {toast} from "react-toastify";
import Config from "./Config";
import {Popover, PopoverHeader, PopoverBody} from 'reactstrap';
import Currency from './partials/Currency';
import ClipLoader from "react-spinners/ClipLoader";
import Valuation, {ValuationContainer} from './partials/Valuation';
import SquadHeader from './partials/SquadHeader'
import ReactGA from "react-ga4";
import addDefaultSrc from "./partials/ImageErrorHandler";
import {setCaptain} from "./partials/ApiCalls";

const GOALKEEPER = Config.GOALKEEPER;
const LEFT_WING = Config.LEFT_WING;
const RIGHT_WING = Config.RIGHT_WING;
const CENTER_BACK = Config.CENTER_BACK;
const LEFT_BACK = Config.LEFT_BACK;
const RIGHT_BACK = Config.RIGHT_BACK;
const PIVOT = Config.PIVOT;
const BENCH = Config.BENCH;

const positionMap = {
    [`${GOALKEEPER}`]: 'goalkeeper',
    [`${LEFT_BACK}`]: 'leftBack',
    [`${CENTER_BACK}`]: 'centerBack',
    [`${RIGHT_BACK}`]: 'rightBack',
    [`${PIVOT}`]: 'pivot',
    [`${RIGHT_WING}`]: 'rightWing',
    [`${LEFT_WING}`]: 'leftWing'
};

const chooseCaptainText = _('Choose captain');

export default function MySquad({squad, fetchSquads, navbar, isMobile, project="supermanager", squads, selectAnotherTeam, tournament}) {
    let [squadIds, setDataSquadIds] = useState([]);

    useEffect(() => {
        squad.squad_members.map(p => squadReference.changeMemberInSquad(p.position, p))
        setDataSquadIds(squad.squad_members.map(player => player.id))
    }, [squad]);

    useEffect(() => {
        ReactGA.initialize(Config.GA_CODE);
        ReactGA.send({hitType: "pageview", page: "/squad/", title: "Squad"});
        fetchSquads()
    }, []); // eslint-disable-line

    return <Squad squad={squad} fetchSquadHandler={fetchSquads} squadIds={squadIds} project={project} navbar={navbar} isMobile={isMobile} squads={squads} selectAnotherTeam={selectAnotherTeam} tournament={tournament}/>
}

let squadReference = null;

const changeMemberInSquadToEmpty = function(position) {
    const newEmptyMember = {...Config.emptyMember, position: position};
    squadReference?.changeMemberInSquad(position, newEmptyMember);
}

class Squad extends Component {
    constructor() {
        super();
        this.state = {
            squad: null,
            goalkeeper: Object.assign({...Config.emptyMember}, {position: GOALKEEPER, position_abbreviation: _('GK')}),
            leftBack: Object.assign({...Config.emptyMember}, {position: LEFT_BACK, position_abbreviation: _('LB')}),
            centerBack: Object.assign({...Config.emptyMember}, {position: CENTER_BACK, position_abbreviation: _('CB')}),
            rightBack: Object.assign({...Config.emptyMember}, {position: RIGHT_BACK, position_abbreviation: _('RB')}),
            leftWing: Object.assign({...Config.emptyMember}, {position: LEFT_WING, position_abbreviation: _('LW')}),
            pivot: Object.assign({...Config.emptyMember}, {position: PIVOT, position_abbreviation: _('P')}),
            rightWing: Object.assign({...Config.emptyMember}, {position: RIGHT_WING, position_abbreviation: _('RW')}),
            tournament: null,
            transactionInProgress: false,
            positionFilter: 0,
            reverting: false,
            bench: [],
            playerInFieldClasses: 'player-in-field ',
            backgroundCourt: 'background-squad',
        }
        squadReference = this
    }

    setPositionFilter(position) {
        this.setState({positionFilter: position})
    }

    setTransactionInProgress(state) {
        this.setState({transactionInProgress: state})
    }

    componentDidMount() {
      this.parseSquad(this.props.squad)
      this.render();
  }

    componentDidUpdate() {
        if(this.props?.squad?.id !== undefined && this.state?.squad?.id !== this.props.squad.id) {
            this.parseSquad(this.props.squad)
            this.render();
        }
    }

    parseSquad(squad) {
        new Promise((resolve, reject) => this.setState({squad: squad, bench: []}, resolve)).then(() => {
            let member = null;
            let position = null;
            for (let i = 0; i < squad.squad_members.length; i++) {
                member = squad.squad_members[i];
                position = member.position;
                this.changeMemberInSquad(position, member);
            }
        });
    }

    changeMemberInSquad(position, member) {
        if (position in positionMap) {
            const stateKey = positionMap[position];
            if (this.state[stateKey].id !== member.id) {
                this.setState({[stateKey]: member});
            }
        }
        else if (position === BENCH && !this.playerAlreadyInBench(member.id)) {
            this.state.bench.push(member);
            this.forceUpdate();
        }
    }

    setCaptain(id, position) {
        id = parseInt(id);
        position = parseInt(position);
        let squadCopy = this.state.squad;
        if(isNaN(id)) {
            return;
        }
        for (let i = 0; i < squadCopy.squad_members.length; i++) {
            let isCaptain = false;
            let member = squadCopy.squad_members[i];
            if(member.id === id) {
                isCaptain = true;
            }
            else {
                const stateKey = positionMap[member.position];
                member.is_captain = false;
                this.setState({[stateKey]: member});
            }
            squadCopy.squad_members[i].is_captain = isCaptain;
        }
        this.setState({squad: squadCopy});

        let newStates = {}
        for(const [key, value] of Object.entries(positionMap)) {
            const stateKey = positionMap[key];
            let memberToChange = this.state[stateKey];
            memberToChange.is_captain = false;
            newStates[stateKey] = memberToChange;
        }

        try {
            const stateKey = positionMap[position];
            let memberToChange = this.state[stateKey];
            memberToChange.is_captain = true;
            newStates[stateKey] = memberToChange
            this.setState(newStates);
        }
        catch(e) {
            console.log("error", e);
            window.location.reload();
        }
    }

    playerAlreadyInBench(playerId) {
        if (playerId === null) {
            return false;
        }
        return this.state.bench.find(player => player.id === playerId)
    }

    swapPlayers(playerInBenchId, playerInBenchPosition) {
        const MAX_BENCH_PLAYERS = 4;
        let playerInBench = null;
        for (let i = 0; i < MAX_BENCH_PLAYERS; i++) {
            let tempPlayer = this.state.bench[i];
            if (tempPlayer?.id === playerInBenchId) {
                playerInBench = tempPlayer;
                this.state.bench.splice(i, 1);
                this.forceUpdate()
                break;
            }
        }
        if (playerInBench === null) {
            throw new Error(_("Either player in bench or player position in bench not found"))
        }

        let targetPlayer = Config.emptyMember;
        let position = playerInBenchPosition;
        playerInBench.position = playerInBenchPosition;
        const positionKey = positionMap[position];
        if (positionKey) {
            targetPlayer = this.state[positionKey];
            let newState = {[positionKey]: playerInBench}
            this.setState(newState);
        }
        targetPlayer.position = BENCH;
        targetPlayer.is_captain = false;
        if (!this.playerAlreadyInBench(targetPlayer.id)) {
            this.state.bench.push(targetPlayer);
            this.forceUpdate()
        }
    }

    revertChanges(e) {
        if(squadReference?.state?.squad?.id === undefined) {
            window.location.href = Config.logoutPage;
            return;
        }
        toast.info(_('Reverting changes'), Config.toastConfig);
        squadReference.setState({reverting: true, bench: []});
        let API_URL = Config.revertChangesUrl.replace("/0/", "/"+squadReference.state.squad.id+"/");
        fetch(API_URL, {
            method: 'PUT',
            headers: {
                Authorization: 'Token '+token,
                'Content-Type': 'application/json'
            }
        })
        .then((ev) => ev.json())
        .then((ev, data) => {
            squadReference.props.fetchSquadHandler();
        })
        .then(() => {
            try {
                ReactGA.event({
                    action: "revert",
                    category: 'revert',
                    label: squadReference?.state?.squad?.name
                })
            } catch(e) {
                console.error(e);
            }
        })
        .catch(
            (e) => { console.log("on error"); console.log(e); toast.error(_(e), Config.toastConfig) }
        )
        .finally(() => squadReference.setState({reverting: false}));
    }

    chooseCaptain() {
        if(squadReference.state.playerInFieldClasses.includes('player-in-field-selecting-captain')) {
            squadReference.setState({
                playerInFieldClasses: 'player-in-field ',
                backgroundCourt: 'background-squad '
            })
        }
        else {
            // step 1: background gets black, (existing) players to top
            // to all player-in-field add player-in-field-selecting-captain
            squadReference.setState({
                playerInFieldClasses: 'player-in-field player-in-field-selecting-captain ',
                backgroundCourt: 'background-squad background-squad-blur'
            })
        }
    }

    captainChoosen() {
        // step 2: Select captain (or cancel)

        // step 3: Send to back

        // Step 4: On OK, show bracelet
        squadReference.setState({playerInFieldClasses: 'player-in-field '})
    }

    sellPlayer(e) {
        const player_id = e.currentTarget.dataset.player;
        if(player_id === undefined) {
            return;
        }
        if(!window.confirm(_("Are you sure you want to sell this player?"))) {
            return;
        }

        let API_URL = Config.sellPlayerUrl;
        API_URL = API_URL.replace("/0/", "/"+player_id+"/")

        fetch(API_URL, {
            method: 'DELETE',
            headers: {
                Authorization: 'Token '+token,
                'Content-Type': 'application/json'
            }
        })
        .then((ev) => ev.json())
        .then((ev, data) => {
            if(ev.position !== BENCH) {
                changeMemberInSquadToEmpty(ev.position);
            }
            else {
                squadReference.setState({bench: []})
            }
            new Promise((resolve, reject) => resolve(squadReference.props.fetchSquadHandler()))
            if(!ev.detail) {
                toast.success(_("Player sold"), Config.toastConfig)
            }
            else {
                try {
                    let message = Config.errorMessages[e?.detail];
                    if(message === undefined) {
                        console.error(e.detail);
                        message = _('Unable to sell player');
                    }
                    toast.error(message, Config.toastConfig)
                }
                catch(e) {
                    toast.error(_(ev?.detail), Config.toastConfig)
                }
            }
        }).catch(
            (e) => { console.log("on error"); console.log(e); toast.error(_(e), Config.toastConfig) }
        )
    }

    render() {
        return <Container className="w-100">
            <div id="coverage" className={this.state.backgroundCourt}></div>
            <SquadHeader squadId={this.props.squad?.id}
                         name={this.props.squad ? this.props.squad?.name : ''}
                         squad={this.props.squad}
                         budget={this.props.squad?.budget}
                         pointsLastWeek={this.props.squad?.points_last_week}
                         changeWindow={this.props.squad?.change_window}
                         nextChangeWindowDateStart={this.props.squad?.next_change_window_date_start}
                         updateSquadHandler={this.props.fetchSquadHandler}
                         project={this.props.project}
                         isMobile={this.props.isMobile}
                         squads={this.props.squads}
                         selectAnotherTeam={this.props.selectAnotherTeam}
            />
            {!this.props.isMobile && this.props.navbar}

            <Row className="mt-4">
                <Col xs={12} md={6} className="text-center court-container w-50">
                    <div className="d-flex display-content-center justify-content-center">
                        <div className="court">
                            <div className="d-flex flex-row justify-content-center mt-2">
                                <>
                                <FontAwesomeIcon icon={faRing}
                                     onClick={this.chooseCaptain}
                                     className="link choose-captain"
                                     alt={chooseCaptainText}
                                />
                                {/*<FontAwesomeIcon icon={faC} onClick={this.chooseCaptain} className="link choose-captain"/>*/}
                                </>
                                <FieldPlayer member={this.state.goalkeeper} fieldPlayerClass={this.state.playerInFieldClasses + "player-in-field-goalkeeper"}
                                             sellMethod={this.sellPlayer}/>
                                <FontAwesomeIcon icon={faRecycle} onClick={this.revertChanges} className="link revert-changes"/>
                            </div>
                            <div className="d-flex flex-row justify-content-between mt-2">
                                <FieldPlayer member={this.state.leftWing} fieldPlayerClass={this.state.playerInFieldClasses + "player-in-field-left-wing"}
                                             sellMethod={this.sellPlayer}/>
                                <FieldPlayer member={this.state.pivot} fieldPlayerClass={this.state.playerInFieldClasses + "player-in-field-pivot"}
                                             sellMethod={this.sellPlayer}/>
                                <FieldPlayer member={this.state.rightWing} fieldPlayerClass={this.state.playerInFieldClasses + "player-in-field-right-wing"}
                                             sellMethod={this.sellPlayer}/>
                            </div>
                            <div className="d-flex flex-row justify-content-between mt-2">
                                <FieldPlayer member={this.state.leftBack} fieldPlayerClass={this.state.playerInFieldClasses + "player-in-field-left-back"}
                                             sellMethod={this.sellPlayer}/>
                                <FieldPlayer member={this.state.centerBack}
                                             fieldPlayerClass={this.state.playerInFieldClasses + "player-in-field-center-back"}
                                             sellMethod={this.sellPlayer}/>
                                <FieldPlayer member={this.state.rightBack} fieldPlayerClass={this.state.playerInFieldClasses + "player-in-field-right-back"}
                                             sellMethod={this.sellPlayer}/>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex display-content-center justify-content-center">
                        <div className="w-100 mt-3 bench-title h4">{_('Bench')}</div>
                    </div>
                    <div className="d-flex display-content-center justify-content-center">
                        <div className="bench w-100 mb-2">
                            <div className="d-flex flex-row justify-content-around pt-3 bench-flex"
                                style={{backgroundImage: `url("${Config.handballBenchUrl}")`}}
                            >
                                <FieldPlayer member={this.state.bench[0]} fieldPlayerClass="player-in-bench"
                                             sellMethod={this.sellPlayer}
                                             transactionInProgress={this.state.transactionInProgress}/>
                                <FieldPlayer member={this.state.bench[1]} fieldPlayerClass="player-in-bench"
                                             sellMethod={this.sellPlayer}
                                             transactionInProgress={this.state.transactionInProgress}/>
                                <FieldPlayer member={this.state.bench[2]} fieldPlayerClass="player-in-bench"
                                             sellMethod={this.sellPlayer}
                                             transactionInProgress={this.state.transactionInProgress}/>
                                <FieldPlayer member={this.state.bench[3]} fieldPlayerClass="player-in-bench"
                                             sellMethod={this.sellPlayer}
                                             transactionInProgress={this.state.transactionInProgress}/>
                            </div>
                        </div>
                    </div>
                    {this.state.reverting && <div className="revert-spinner">
                        <ClipLoader
                            color="#23a6da"
                            loading={this.state.reverting}
                            size={200}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        />
                    </div>}
                    <div className="banner banner-middle mb-3 d-none">
                    {this.props.project === 'asobal' &&
                        <img src={Config.imgBannerMiddleUrl} alt={Config.imgBannerMiddleText}/>
                    }
                    </div>
                </Col>
                <PlayerList squadIds={this.props.squadIds} updateSquadHandler={this.props.fetchSquadHandler} positionFilterFromSquad={this.state.positionFilter} tournament={this.props.tournament}/>
            </Row>
        </Container>
    }
}

function getPlayerPositionClass(position) {
    let className = '.player-in-field-'
    const positions = {
        GOALKEEPER: 'goalkeeper',
        CENTER_BACK: 'center-back',
        RIGHT_BACK: 'right-back',
        LEFT_BACK: 'left-back',
        PIVOT: 'pivot',
        RIGHT_WING: 'right-wing',
        LEFT_WING: 'left-wing',
        BENCH: 'reserve'
    }
    return className + positions[position];
}

const FieldPlayer = function ({member, fieldPlayerClass = null, sellMethod, transactionInProgress, chooseCaptain}) {
    const [swapping, setSwapping] = useState(false);
    const [position, setPosition] = useState("")
    const [open, setOpen] = useState(false)
    const injuredIconStyle = { color: 'white', 'position': 'absolute', 'top': '-63px', 'left': '-28px'};
    const injuredIconStyleBack = { color: 'red', 'position': 'absolute', 'top': '-61px', 'left': '-28px', height:'12px'};
    const captainIconStyle = { color: 'gold', 'position': 'absolute', 'top': '-50px', 'left': '-28px', height: '6px'};
    const captainIconStyleBack = { color: '#202020', 'position': 'absolute', 'top': '-61px', 'left': '-28px', height:'25px'}

    if(member === null || member === undefined) {
        member = Config.emptyMember
    }

    useEffect(function() {
        setPosition(member.position_abbreviation)
    }, []) // eslint-disable-line

    useEffect(function() {
        if(member.id !== 0 && member.id !== null) {
            setPosition(member.position_abbreviation)
        }
        if(member.position === 0) {
            setPosition("")
        }
        if(member.id === null && member.position === BENCH) {
            setPosition("")
        }
    }, [member])


    if(fieldPlayerClass === null) {
        fieldPlayerClass = getPlayerPositionClass(member.position)
    }

    const toggle = function(e) {
      setOpen(!open);
    }

    const toFilter = function (e) {
        document.getElementById('playerList').scrollIntoView();
        const position = Number.parseInt(e.currentTarget.dataset.position);
        squadReference.setPositionFilter(position)
    }

    const classes = "player-in-field image-squad "+fieldPlayerClass;
    let imageClasses = "image-squad";
    if(member.injured) {
        imageClasses += " image-squad-injured";
    }

    const injuredText = _('Injured');

    const swapPlayer = function (e) {
        if (swapping || transactionInProgress) {
            return;
        }
        setSwapping(true);
        squadReference.setTransactionInProgress(true);
        const playerId = e.currentTarget.dataset.playerId;
        fetch(Config.changePlayerInSquadUrl.replace("/0/", "/" + playerId + "/"), {
            headers: {
                Authorization: 'Token ' + token,
                'Content-Type': 'application/json'
            },
            method: "PUT",
            data: JSON.stringify({})
        })
        .then((e) => e.json())
        .then((e) => {
            if (e.message === 'success') {
                squadReference.swapPlayers(e.id, e.position);
            }
            else if (e?.detail !== undefined) {
                toast.error(Config.errorMessages[e?.detail], Config.toastConfig)
            }
            return true;
        })
        .catch((e) => {
            console.log(e)
            toast.error("No se ha podido cambiar al jugador: " + e, Config.toastConfig)
            window.location.reload();
        }).finally(() => {
            setSwapping(false);
            squadReference.setTransactionInProgress(false);
        })
    }

    const getPriceColor = function() {
        let color = null;
        if(member.buy_price < member.current_price) {
            color = 'green';
        }
        else if(member.buy_price > member.current_price) {
            color = 'red';
        }
        return color;
    }

    let popover = '';
    const ref = useRef(null)
    if(member.id) {
        let placement = "bottom";
        if([RIGHT_BACK, RIGHT_WING].includes(member.position)) {
            placement = "right";
        }
        if([LEFT_BACK, LEFT_WING].includes(member.position)) {
            placement = "left";
        }

        const color = getPriceColor(member);

        const teamName = _(member.team_name.replace(" (F)", ""))
        const flag =  process.env.REACT_APP_STATIC_URL + member.team_flag

        popover = (
            <Popover placement={placement} isOpen={open} target={ref} toggle={toggle}
                     onClick={toggle}>
                <PopoverHeader className="font-weight-bold squad-popover">{member.name.toLowerCase()}</PopoverHeader>
                <PopoverBody>
                    <div><span>
                        <img src={flag} alt={teamName} className="player-list-flag"/> {teamName}
                    </span></div>
                    <div><span>{_('Buy price')}</span><span className="float-right text-right">
                  <Currency value={member.buy_price}/></span></div>
                    <div>{_('Current price')}<span className="float-right text-right">
                  <Currency value={member.current_price} color={color}/></span></div>
                    {member.next_match.local_team_id && parseInt(member.team_id) === member.next_match.local_team_id &&
                        <div className="w-100" style={{'position': 'relative', 'display': 'inline-block'}}>
                            <div className="float-left">{_('Next match')}</div>
                            <div className="float-right text-right"><FontAwesomeIcon
                                icon={faHome}/> {_(member.next_match.away_team_name)}</div>
                        </div>
                    }
                    {member.next_match.local_team_id && parseInt(member.team_id) === member.next_match.away_team_id &&
                        <div className="w-100" style={{'position': 'relative', 'display': 'inline-block'}}>
                            <div className="float-left text-left">{_('Next match')}</div>
                            <div className="float-right text-right"><FontAwesomeIcon
                                icon={faPlaneDeparture}/> {_(member.next_match.local_team_name)}</div>
                        </div>
                    }
                    <div>{_('Last 3 matches')}
                        <ValuationContainer valuations={member.last_3_valuations}/>
                    </div>
                    {member.injured &&
                    <div className="text-danger font-weight-bold">
                        {_('Injured')}
                    </div>
                    }
                </PopoverBody>
            </Popover>
        )
    }

    const imgMemberClassName = (member.id === 0 || member.id === null) ? 'image-squad' : imageClasses;
    const actionOnClick = function(e) {
        if(fieldPlayerClass.includes('player-in-field-selecting-captain')) {
            setCaptain(e);
            squadReference.setCaptain(e.currentTarget.dataset.playerId, e.currentTarget.dataset.position);
            squadReference.chooseCaptain();
        }
        else if (member.id === 0 || member.id === null) {
            toFilter(e);
        }
        else {
            toggle(e);
        }
    }

    return (
        <div className={classes}>
            <img onError={addDefaultSrc} src={`${member.image_link}`} className={imgMemberClassName} loading="lazy" alt={member.name}
                 title={member.name} ref={ref} id={"squad-player-" + member.id} onClick={actionOnClick} data-position={member.position}
                 data-player-id={member.id}/>
            <div className="squad-player-options d-flex">
                {member.position === BENCH && member.id !== 0 && !swapping && !transactionInProgress ? (
                        <div className="link swap"
                             onClick={swapPlayer}
                             data-player-id={member.player_in_squad_id}
                        >
                            <FontAwesomeIcon icon={faArrowsUpDown} style={{"minWidth": "25px"}} className="mt-2"/>
                        </div>)
                    : ""
                }
                <div className="squad-loading-spinner">
                    <ClipLoader
                        color="#23a6da"
                        loading={swapping}
                        size={20}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                </div>
                <span className="position">{_(position)}</span>&nbsp;
                <Valuation valuation={member.now_playing ? member.last_3_valuations[0] : member.last_valuation} isPlaying={member.now_playing}/>
                &nbsp;
                <div className="link sell" data-player={member.id} onClick={sellMethod} data-position={member.position}>
                    {
                        member.id === null
                            ?
                            <FontAwesomeIcon icon={faMoneyBillTransfer} className="mt-2 transparent" data-player={member.id} style={{'fontSize': '1.2rem'}}/>
                            : <FontAwesomeIcon icon={faMoneyBillTransfer} className="mt-2" data-player={member.id} style={{'fontSize': '1.2rem'}}/>
                    }
                </div>
                {member.injured &&
                <div className="fa-stack" style={{ height: 'auto', width: 'auto'}}>
                   <FontAwesomeIcon icon={faCircle} className="fa-solid fa-stack-1x" style={injuredIconStyleBack} alt={injuredText}/>
                   <FontAwesomeIcon icon={faSuitcaseMedical} className="fab fa-stack-1x fa-inverse" style={injuredIconStyle} alt={injuredText}/>
                </div>
                }
                <div className="fa-stack" style={{height: 'auto', width: 'auto'}}>
                    {
                        member.is_captain &&
                        <>
                        <FontAwesomeIcon icon={faRing} className="fa-solid fa-stack-1x"
                             style={captainIconStyleBack}
                             alt={injuredText}/>
                        <FontAwesomeIcon icon={faC} className="fab fa-stack-1x fa-inverse" style={captainIconStyle}
                                         alt={injuredText}/>
                        </>
                    }
                </div>
            </div>
            {popover}
        </div>
    )
}

export {changeMemberInSquadToEmpty};